import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';

export const getAllSupplierAnnouncementSlice = createApi(`GetAllSupplierAnnouncementSlice`,"GET");

const GetAllSupplierAnnouncementSlice = createSlice({
  name: 'GetAllSupplierAnnouncementSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllSupplierAnnouncementSlice.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllSupplierAnnouncementSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getAllSupplierAnnouncementSlice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default GetAllSupplierAnnouncementSlice.reducer;